import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, requiredRole }) => {
    const { currentUser } = useAuth();
    const storedToken = localStorage.getItem('token');
    const storedRole = localStorage.getItem('role');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    console.log('PrivateRoute: currentUser:', currentUser);
    console.log('Stored token:', storedToken);
    console.log('Stored role:', storedRole);
    console.log('Required role:', requiredRole);

    if (loading) return <p>Loading authentication...</p>;

    if (!storedToken || !storedRole) {
        console.warn('No token or role found, redirecting to login.');
        return <Navigate to="/login" />;
    }

    if (requiredRole && storedRole !== requiredRole) {
        console.warn(`User role (${storedRole}) does not match required role (${requiredRole}), redirecting.`);
        return <Navigate to="/login" />;
    }

    return children;
};

export default PrivateRoute;
